var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgC(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "C",
    transform: "translate(13317 17163)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4021",
    "data-name": "Rectangle 4021",
    width: 60,
    height: 60,
    transform: "translate(-13317 -17163)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13324",
    "data-name": "Group 13324",
    transform: "translate(-570.5 -3.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6407",
    "data-name": "Path 6407",
    d: "M56.532,18.5H30.685a8.5,8.5,0,0,0-8.493,8.493v2.585H19.608a1.108,1.108,0,0,0,0,2.215h2.585v8.862H19.608a1.108,1.108,0,0,0,0,2.215h2.585v8.862H19.608a1.108,1.108,0,0,0,0,2.215h2.585v2.585a8.5,8.5,0,0,0,8.493,8.493H56.532a8.5,8.5,0,0,0,8.493-8.493V26.993A8.5,8.5,0,0,0,56.532,18.5Zm6.277,38.032a6.284,6.284,0,0,1-6.277,6.277H30.685a6.284,6.284,0,0,1-6.277-6.277V53.947h2.585a1.108,1.108,0,1,0,0-2.215H24.408V42.87h2.585a1.108,1.108,0,0,0,0-2.215H24.408V31.793h2.585a1.108,1.108,0,0,0,0-2.215H24.408V26.993a6.284,6.284,0,0,1,6.277-6.277H56.532a6.284,6.284,0,0,1,6.277,6.277Z",
    transform: "translate(-12758 -17171.5)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6408",
    "data-name": "Path 6408",
    d: "M53.674,49.1H47.7a9.206,9.206,0,0,0-9.2,9.2v1.157a5.158,5.158,0,0,0,5.152,5.155H57.718a5.158,5.158,0,0,0,5.152-5.155V58.3a9.206,9.206,0,0,0-9.2-9.2Zm6.981,10.354a2.942,2.942,0,0,1-2.937,2.94H43.652a2.942,2.942,0,0,1-2.937-2.94V58.3A6.988,6.988,0,0,1,47.7,51.318h5.977A6.988,6.988,0,0,1,60.654,58.3Z",
    transform: "translate(-12763.23 -17179.504)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6409",
    "data-name": "Path 6409",
    d: "M52.725,42.75A6.425,6.425,0,1,0,46.3,36.326,6.428,6.428,0,0,0,52.725,42.75Zm0-10.633v0a4.21,4.21,0,1,1-4.209,4.212,4.212,4.212,0,0,1,4.209-4.212Z",
    transform: "translate(-12765.271 -17174.48)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC);
export default __webpack_public_path__ + "static/media/C.f065e7d0324a5c5eb733f48eebb6c796.svg";
export { ForwardRef as ReactComponent };